import React from 'react';
import RefreshIcon from '@material-ui/icons/Refresh';
import { ChatMessages, MessageComposer } from 'features/message-center';
import { useChatV2 } from 'features/message-center/hooks';
import strings from 'strings';
import { FPIconButton } from 'UI/components/atoms';
import DrawerContentLayout from 'UI/components/templates/DrawerContentLayout';
import { UIStatus } from 'UI/constants/status';
import { formatInternationalPhone } from 'UI/utils';

import { useStyles } from './ChatDrawerContent.styled';

export const ChatDrawerContent = ({
  isDrawerOpen,
  closeDrawer,
  recipient,
  recipientPhoneWithCode
}) => {
  const classes = useStyles();

  const {
    chat,
    chatStatus,
    handleClickRetry,
    handleClickSend,
    handleFetchMoreMessages,
    handleRefreshConversation,
    shouldScrollToBottom
  } = useChatV2({
    externalNumber: recipientPhoneWithCode
  });

  const title = recipient?.name ?? recipient?.personalInformation?.full_name ?? '';
  const countryCode = recipient?.countryCode ?? '+1';
  const subheader = recipient?.phone
    ? formatInternationalPhone(`${countryCode}${recipient.phone}`)
    : '';

  return (
    <DrawerContentLayout
      title={title}
      subheader={subheader}
      additionalHeaderButtons={
        <FPIconButton
          onClick={handleRefreshConversation}
          tooltipProps={{
            title: strings.messageCenter.chat.refresh
          }}
        >
          <RefreshIcon />
        </FPIconButton>
      }
      CustomFooter={
        <MessageComposer
          disabled={chatStatus !== UIStatus.Success}
          onClickSend={handleClickSend}
          showSelectMultipleLine
        />
      }
      customDrawerToolbarClass={classes.customDrawerToolbar}
      drawerProps={{
        open: isDrawerOpen
      }}
      contentProps={{ className: classes.drawerContent }}
      onClose={closeDrawer}
    >
      <ChatMessages
        chat={chat}
        chatStatus={chatStatus}
        onClickRetry={handleClickRetry}
        onFetchMoreMessages={handleFetchMoreMessages}
        shouldScrollToBottom={shouldScrollToBottom}
      />
    </DrawerContentLayout>
  );
};
